module.exports = __webpack_public_path__ + "img/totalizador-inconforme-dashboard.6a826395.svg";